
import { supabase } from "@/integrations/supabase/client";

export interface UserWithSubscription {
  id: string;
  email: string;
  full_name: string;
  created_at: string;
  subscription?: {
    id: string;
    status: string;
    plan: string;
    amount: number;
    end_date: string;
  };
}

export const USERS_PER_PAGE = 50;

// Fetch users + latest subscription (no N+1)
export const fetchUsers = async (searchTerm: string, page: number) => {
  let query = supabase
    .from('profiles')
    .select('id, email, full_name, created_at')
    .order('created_at', { ascending: false })
    .range(page * USERS_PER_PAGE, page * USERS_PER_PAGE + USERS_PER_PAGE - 1);

  if (searchTerm) {
    query = query.or(
      `email.ilike.%${searchTerm}%,full_name.ilike.%${searchTerm}%`
    );
  }

  const { data: users, error } = await query;
  if (error) throw new Error(error.message || "Failed to fetch users.");

  // Batch fetch subscriptions for this chunk
  const userIds = (users || []).map((u: any) => u.id);
  let subscriptions: Record<string, any> = {};
  if (userIds.length > 0) {
    const { data: subscriptionRows, error: subError } = await supabase
      .from('user_subscriptions')
      .select('id, user_id, status, plan, amount, end_date, created_at')
      .in('user_id', userIds)
      .order('created_at', { ascending: false });

    if (subError) throw new Error(subError.message || "Failed to fetch subscriptions.");
    // Only pick the latest subscription per user (guaranteed by order above)
    for (const row of subscriptionRows || []) {
      if (!subscriptions[row.user_id]) {
        subscriptions[row.user_id] = row; // first is latest
      }
    }
  }
  // Map latest subscription to each user
  const result = (users || []).map((profile: any) => ({
    ...profile,
    subscription: subscriptions[profile.id] || null,
  }));

  return result as UserWithSubscription[];
};
